import clsx from "clsx";

import { ArcadeTimer } from "../../../shared/components/arcade-timer.component";
import { PuzzleRoundStatusEnum } from "../../widget.types";

export function PuzzleBanner({
  correctTiles,
  totalTiles,
  brandName,
  logoUrl,
  brandShortDescription,
  status,
  onTimeout,
}: {
  correctTiles: number;
  totalTiles: number;
  brandName: string;
  logoUrl: string;
  brandShortDescription: string;
  status: PuzzleRoundStatusEnum;
  onTimeout: () => void;
}) {
  return (
    <div
      className={clsx(
        "arcade__puzzle__banner",
        correctTiles === totalTiles && "round--completed"
      )}
    >
      <div className="arcade-puzzle-black-banner--left">
        <div className="arcade-puzzle-black-banner--entries-container">
          <div className="arcade-puzzle-black-banner--left-entries">
            <span>+{totalTiles}</span> points
          </div>
        </div>
        <div className="arcade-puzzle-black-banner--left-tiles">
          <div className="arcade-puzzle-black-banner--left-correct-tiles">
            Correct tiles: {correctTiles}/{totalTiles}
          </div>
          <span className="arcade-puzzle-black-banner--left-sponsored">
            This round sponsored by {brandName}
          </span>
          <div className="arcade-puzzle-black-banner--left-logo">
            <img src={logoUrl} alt="Brand logo" />
          </div>
        </div>
      </div>
      <div className="arcade__puzzle__banner__center">
        <ArcadeTimer
          isRunning={status === PuzzleRoundStatusEnum.STARTED}
          time={45}
          onTimeout={onTimeout}
        />
      </div>
      <div className="arcade__puzzle__banner__right">
        <img
          className="arcade__puzzle__banner__right--brand-logo"
          src={logoUrl}
          alt="Brand logo"
        />
        <div className="arcade__puzzle__banner__right--short-description">
          {brandShortDescription}
        </div>
      </div>
    </div>
  );
}
